/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { komboIntegrationDataIntegrationTypeSchema } from './KomboIntegrationDataIntegrationTypeSchema'

export const komboIntegrationDataSchema = z.object({
	id: z.string(),
	komboIntegrationId: z.string(),
	komboToolId: z.string(),
	integrationType: komboIntegrationDataIntegrationTypeSchema,
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
})

export type KomboIntegrationDataSchema = z.infer<typeof komboIntegrationDataSchema>
